export type ComponentSizes =
  | 'full'
  | 'xxxlarge'
  | 'xxlarge'
  | 'xlarge'
  | 'large'
  | 'medium'
  | 'sm'
  | 'small'
  | 'xsmall'
  | 'xxsmall'
  | 'xsmall-transparent'
  | CardSizes
  | CounterSizes
  | IconsType;

export type CardSizes =
  | 'aus-secure-checkout-card'
  | 'aus-summary-card'
  | 'card'
  | 'indented-card'
  | 'inner-card'
  | 'card-wide'
  | 'collapsed-card'
  | 'item-card'
  | 'health-card'
  | 'main-health-card'
  | 'cover-card'
  | 'main-cover-card'
  | 'car-rental-card'
  | 'car-rental-inner-card'
  | 'summary-card'
  | 'plan-card'
  | 'best-offer-plan-card'
  | 'summary-wrapper-card'
  | 'thank-you-card'
  | 'benefit-card'
  | 'cc-card'
  | 'flight-delay-card'
  | 'warning-card'
  | 'explanation-card'
  | 'details-card'
  | 'status-info-card';
export type CounterSizes = 'counter-large' | 'counter-small';
export type IconsType =
  | 'add-traveler'
  | 'close-dialog'
  | 'trash-user'
  | 'splash-logo'
  | 'biometric-login'
  | 'affiliate-link'
  | 'plus'
  | 'responsive-icon';

export type TitleSizes = 'title' | 'secondarytitle' | 'subtitle' | 'subsubtitle';

export enum CardSizesEnum {
  Card = 'card',
  InnerCard = 'inner-card',
  CardWide = 'card-wide',
  CollapsedCard = 'collapsed-card',
  ItemCard = 'item-card',
  HealthCard = 'health-card',
  MainHealthCard = 'main-health-card',
  CoverCard = 'cover-card',
  MainCoverCard = 'main-cover-card',
  CarRentalCard = 'car-rental-card',
  CarRentalInnerCard = 'car-rental-inner-card',
  SummaryCard = 'summary-card',
  PlanCard = 'plan-card',
  SummaryWrapperCard = 'summary-wrapper-card',
  ThankYouCard = 'thank-you-card',
  BenefitCard = 'benefit-card',
  CcCard = 'cc-card'
}

export enum CounterSizesEnum {
  CounterLarge = 'counter-large',
  CounterSmall = 'counter-small'
}

export enum ComponentSizesEnum {
  Full = 'full',
  XXXLarge = 'xxxlarge',
  XXLarge = 'xxlarge',
  XLarge = 'xlarge',
  Large = 'large',
  Medium = 'medium',
  Sm = 'sm',
  Small = 'small',
  XSmall = 'xsmall',
  XXSmall = 'xxsmall',
  XSmallTransparent = 'xsmall-transparent'
}
